<template>
  <v-app id="inspire" dark>
    <v-navigation-drawer
      clipped
      persistent
      v-model="drawer"
      enable-resize-watcher
      app
      temporary
      fixed
    >
      <v-list dense>
        <v-list-tile v-for="item in menuItems"
        :key="item.title"
        :to="item.link">
          <v-list-tile-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
       
    </v-navigation-drawer>

    <v-toolbar app fixed clipped-left>
    <!-- <v-toolbar app  clipped-left> -->
    

      <v-toolbar-title ><router-link to="/">AWARDS 2017</router-link></v-toolbar-title>
       
      <v-spacer></v-spacer>
       <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-only hidden-md-only hidden-lg-only hidden-xl-only "></v-toolbar-side-icon>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat class="white--text"
        v-for="item in menuItems"
        :key="item.link"
        :to="item.link"
        >
          <v-icon left >{{item.icon}}</v-icon>
              {{item.title}}
          </v-btn>
     </v-toolbar-items>
     
    </v-toolbar>

    <main class="main-content">
      <router-view></router-view>
    </main>
      <sub-footer class="subFooter">
        <v-layout justify-center align-center class="ma-0 pa-0">
         
          <v-btn flat :href="'http://tourdehdr.sakuratan.com/site2/'" target="_blank" style=" padding-top:1rem;">
              <p class="text-xs-center text-sm-center text-md-center text-lg-center text-xl-center white--text">TOURdeHDR+2017</p>
          </v-btn>
       

        </v-layout>
        
       
          <v-layout justify-center align-center class="ma-0 pa-0">
            <v-tooltip right>
              <v-btn icon large :href="'https://plus.google.com/+YoshiakiHiramatsu'" target="_blank" slot="activator">
                <icon name="google-plus" scale="2" class="mb-1"></icon>
              </v-btn>
              <span>Google+</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn icon large :href="'https://twitter.com/TOURdeHDR'" target="_blank" slot="activator">
                <icon name="twitter" scale="2" class="mb-1"></icon>
              </v-btn>
              <span>Twitter</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn icon large :href="'https://www.facebook.com/tourdehdr/'" target="_blank" slot="activator">
                <icon name="facebook" scale="2" class="mb-1"></icon>
              </v-btn>
              <span>Twitter</span>
            </v-tooltip>
          </v-layout>

        </v-container>
      </sub-footer>
   

    <v-footer app >
      <!-- <p>TOURdeHDR+2017</P> -->
      <!-- <a href="http://tourdehdr.sakuratan.com/site2/" target="_blank" class="mt-4 d-inline-block"><p class=" white--text"><icon name="wordpress" scale="2"></icon></p></a>
      <a href="https://plus.google.com/+YoshiakiHiramatsu" target="_blank" class="mt-4 pl-2 d-inline-block"><p class=" white--text"><icon name="google-plus" scale="2" class="mb-1"></icon></p></a>
      <a href="https://twitter.com/TOURdeHDR" target="_blank" class="mt-4 pl-2 d-inline-block"><p class=" white--text"><icon name="twitter" scale="2" class="mb-1"></icon></p></a> -->
      
       <!-- <v-icon>cloud_upload</v-icon> -->
       
      <v-btn
        v-if="!userIsAuthenticated"
        flat
         @click="onLogin"
        >
        <v-icon left dark>lock_open</v-icon>
        <!-- Login -->
      </v-btn>
      <v-btn
        v-if="userIsAuthenticated"
        flat
         @click="onUpload"
        >
        <v-icon left dark>cloud_upload</v-icon>
        <!-- Upload -->
      </v-btn>
      <v-btn
     
          v-if="userIsAuthenticated"
          flat
          @click="onLogout">
          <v-icon left dark  class="pr-2 mr-5">exit_to_app</v-icon>
          <!-- Logout -->
        </v-btn>
    </v-footer>
  </v-app>
</template>
<!-- <v-app dark>
    <v-toolbar  >
    <v-toolbar-side-icon></v-toolbar-side-icon>
    <v-toolbar-title class="white--text">TOURdeHDR+2017 DIGEST</v-toolbar-title>
    <v-spacer></v-spacer>
    
    <v-btn flat class="white--text"
      v-for="item in menuItems"
    
      :to="item.link">
      <v-icon>{{item.icon}}</v-icon>
      {{item.title}}
     
    </v-btn>
    
  </v-toolbar>
    
    <main>
    </main>
    <v-footer dark color="primary"
      :fixed="fixed" app >
      <span class="white--text " >&copy; TOURdeHDR+2017 DIGEST</span>
    </v-footer>
  </v-app> -->

<script>
//   export default {
//     data: () => ({
//       drawer: true
//     }),
//     props: {
//       source: String
//     }
//   }
  export default {
    // props: {
    //   source: String
    // },
    
    data () {
      return {
        drawer: false,
        menuItems : [
            {icon: 'account_balance', title: 'AWARDS', link: '/top'},
            {icon: 'widgets', title: 'DIGEST', link: '/home'}
            // {icon: '3d_rotation', title: 'COMPOSITE', link: '/model'}
           
        ],
      }
    },
    computed:{
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }

    },
    methods:{
      onLogout () {
        this.$store.dispatch('logout')
      },
      onLogin () {
        this.$router.push('/signin' )
      },
      onUpload () {
        this.$router.push('/upload' )
      },
      

    }
  }



   
</script>

<style lang="stylus">
  @import './stylus/main'
</style>









// WEBPACK FOOTER //
// src/App.vue